module.exports = __webpack_public_path__ + "img/1_1-commerciale-panettiere-0.27849b63.png";